import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:4000/api"
    : `${typeof window !== "undefined" ? window.location.origin : ""}/api`;

export default function AceptarLlavesPublica() {
  const { token } = useParams();
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    setError("");
    fetch(`${API_BASE}/public/llaves/${encodeURIComponent(token || "")}`)
      .then(async (r) => {
        const j = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(j.error || "No se pudo cargar");
        if (!cancel) setPreview(j.data || null);
      })
      .catch((e) => {
        if (!cancel) setError(e.message || "Error de red");
      })
      .finally(() => {
        if (!cancel) setLoading(false);
      });
    return () => { cancel = true; };
  }, [token]);

  const aceptar = async () => {
    setEnviando(true);
    setError("");
    try {
      const r = await fetch(`${API_BASE}/public/llaves/${encodeURIComponent(token || "")}/aceptar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: "{}",
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || "No se pudo confirmar");
      setResultado(j);
    } catch (e) {
      setError(e.message || "Error al confirmar");
    } finally {
      setEnviando(false);
    }
  };

  const card = {
    width: "min(420px, 94vw)",
    margin: "0 auto",
    padding: "28px 22px",
    borderRadius: 16,
    background: "#fff",
    boxShadow: "0 12px 40px rgba(15,23,42,0.12)",
    fontFamily: "'DM Sans', system-ui, sans-serif",
  };

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f1f5f9" }}>
        <div style={card}>Cargando…</div>
      </div>
    );
  }

  if (resultado?.ok) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f1f5f9", padding: 16 }}>
        <div style={card}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>✅</div>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "#0f172a" }}>
            {resultado.ya_aceptado ? "Ya estaba confirmado" : "Recogida confirmada"}
          </h1>
          <p style={{ margin: "10px 0 0", fontSize: 14, color: "#475569", lineHeight: 1.45 }}>
            {resultado.referencia
              ? `Queda registrado que recoges las llaves de la Ref. ${resultado.referencia}.`
              : "Gracias, queda registrado en Vitalcasa."}
          </p>
        </div>
      </div>
    );
  }

  const motivo = preview && preview.ok === false ? preview.motivo : null;
  const mensajesMotivo = {
    no_encontrado: "Este enlace no es válido o ya no existe.",
    ya_aceptado: `Esta recogida ya fue confirmada${preview?.referencia ? ` (Ref. ${preview.referencia})` : ""}.`,
    caducado: "Este enlace ha caducado. Pide a Vitalcasa que te reenvíen la confirmación.",
    anulado: "Esta entrega ya no está pendiente.",
  };

  if (error || motivo) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f1f5f9", padding: 16 }}>
        <div style={card}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🔑</div>
          <h1 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#0f172a" }}>Llaves Vitalcasa</h1>
          <p style={{ margin: "12px 0 0", fontSize: 14, color: "#64748b", lineHeight: 1.45 }}>
            {error || mensajesMotivo[motivo] || "No se puede usar este enlace."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f1f5f9", padding: 16 }}>
      <div style={card}>
        <div style={{ fontSize: 36, marginBottom: 8 }}>🔑</div>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "#0f172a" }}>
          Confirmar recogida de llaves
        </h1>
        <p style={{ margin: "12px 0 0", fontSize: 14, color: "#475569", lineHeight: 1.5 }}>
          Ref. <strong style={{ color: "#0f172a" }}>{preview?.referencia || "—"}</strong>
          {preview?.poblacion ? ` · ${preview.poblacion}` : ""}
        </p>
        <p style={{ margin: "8px 0 0", fontSize: 13, color: "#64748b" }}>
          {preview?.agencia || "—"} · {preview?.persona || "—"}
        </p>
        <button
          type="button"
          onClick={aceptar}
          disabled={enviando}
          style={{
            marginTop: 22,
            width: "100%",
            padding: "14px 16px",
            borderRadius: 12,
            border: "none",
            background: enviando ? "#94a3b8" : "linear-gradient(135deg, #0369a1, #0ea5e9)",
            color: "#fff",
            fontSize: 15,
            fontWeight: 700,
            cursor: enviando ? "wait" : "pointer",
            fontFamily: "inherit",
          }}
        >
          {enviando
            ? "Confirmando…"
            : `Confirmo que recojo las llaves de Ref. ${preview?.referencia || ""}`}
        </button>
        <p style={{ margin: "14px 0 0", fontSize: 11, color: "#94a3b8", lineHeight: 1.4 }}>
          Al confirmar, Vitalcasa registra que las llaves quedan contigo.
        </p>
      </div>
    </div>
  );
}
